import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { handleMissingTranslation } from './missingTranslationHandler';
import {
  SUPPORTED_LANGUAGES,
  LANGUAGE_STORAGE_KEY,
  normalizeLanguage,
  resolveInitialLanguage,
  detectLanguageByLocation,
  hasManualLanguageChoice,
} from './languageDetection';
import pt from '../locales/pt.json';
import en from '../locales/en.json';
import fr from '../locales/fr.json';
import zh from '../locales/zh.json';

const initialLanguage = resolveInitialLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: pt },
      en: { translation: en },
      fr: { translation: fr },
      zh: { translation: zh },
    },
    lng: initialLanguage,
    fallbackLng: 'en',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    load: 'languageOnly',
    cleanCode: true,
    debug: false,

    react: {
      useSuspense: true,
    },

    interpolation: {
      escapeValue: false,
    },

    saveMissing: true,
    missingKeyHandler: handleMissingTranslation,
  })
  .catch((err) => {
    console.error('[i18n] Initialization error:', err);
  });

// Set HTML lang attribute on change
i18n.on('languageChanged', (lng) => {
  const normalized = normalizeLanguage(lng) || 'pt';
  document.documentElement.lang = normalized;
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, normalized);
    localStorage.setItem('i18nextLng', normalized);
  } catch {
    /* ignore */
  }
});

document.documentElement.lang = initialLanguage;

// Country-based default (lusophone -> pt, otherwise en/fr/zh).
// Never overrides an explicit manual choice from the language selector.
if (!hasManualLanguageChoice()) {
  detectLanguageByLocation()
    .then((detected) => {
      if (detected && !hasManualLanguageChoice() && detected !== normalizeLanguage(i18n.language)) {
        i18n.changeLanguage(detected);
      }
    })
    .catch(() => undefined);
}

export default i18n;
